import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import { property as n } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ButtonStyleTypes } from '../../atoms/buttons/enums.js';
import { setDataAttributes, isRTL } from '../../utilities/dom-helpers/index.js';
import { setLineClamp } from '../../utilities/text-helpers/index.js';
import css_248z from './icons-and-info-block.scss.js';

class IconsAndInfoBlock extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.divider = false;
        this.styleType = ButtonStyleTypes.LIGHT;
        this.headingSlot = null;
        this.textSlot = null;
        this.isIcon = false;
        this.enableSpacing = false;
        this.isLarge = false;
    }
    firstUpdated() {
        setDataAttributes(this, 'heading', null);
        setLineClamp(this, 99, 299);
        this.checkLargeIcons();
        this.handleLargeIcons(this.isLarge);
        IconsAndInfoBlock.ctaClasses();
    }
    checkLargeIcons() {
        const icons = Array.from(this.querySelectorAll('icon-and-info'));
        const hasLargeIcons = icons.some(icon => icon.getAttribute('size') === 'Large');
        this.isLarge = hasLargeIcons;
        return hasLargeIcons;
    }
    handleLargeIcons(largeAttr) {
        if (!largeAttr)
            return;
        const iconsContainer = this.querySelector('.icons-container-slotted');
        iconsContainer === null || iconsContainer === void 0 ? void 0 : iconsContainer.classList.add('icons-container-slotted--large');
    }
    static ctaClasses() {
        const ctaButtons = document.querySelectorAll('generic-button span');
        const filteredCta = Array.from(ctaButtons).filter(span => !span.closest('a.primary-button.style-dark.size-regular'));
        filteredCta.forEach(cta => {
            cta.classList.add('icon-cta');
        });
    }
    static handleSlotChange(event) {
        const slot = event.target;
        const assignedElements = slot.assignedElements({ flatten: true });
        const iconsContainer = assignedElements.find(el => el.classList && el.classList.contains('icons-container-slotted'));
        if (iconsContainer) {
            const icons = Array.from(iconsContainer.querySelectorAll('icon-and-info'));
            IconsAndInfoBlock.setGrid(iconsContainer, icons.length);
            icons.forEach((icon, index) => {
                icon.classList.remove('grid-item-1', 'grid-item-2', 'grid-item-3', 'grid-item-4', 'grid-item-5');
                icon.classList.add(`grid-item-${index + 1}`);
            });
        }
    }
    static setGrid(iconsContainer, icons) {
        switch (icons) {
            case 2:
                iconsContainer.classList.add('icons-container-slotted--grid-2');
                break;
            case 3:
                iconsContainer.classList.add('icons-container-slotted--grid-3');
                break;
            case 4:
                iconsContainer.classList.add('icons-container-slotted--grid-4');
                break;
            case 5:
                iconsContainer.classList.add('icons-container-slotted--grid-5');
                break;
            case 6:
                iconsContainer.classList.add('icons-container-slotted--grid-6');
                break;
            case 7:
                iconsContainer.classList.add('icons-container-slotted--grid-7');
                break;
            case 8:
                iconsContainer.classList.add('icons-container-slotted--grid-8');
                break;
        }
    }
    render() {
        const classes = {
            'icons-and-info-block': true,
            [this.styleType.toLowerCase()]: this.styleType,
            rtl: this.rtl || isRTL(),
            divider: this.divider,
            'icons-grid-container': true,
            'default-space-between-cards': this.enableSpacing,
        };
        return x `<div class="${o(classes)}"><hr class="separator"><header><slot name="heading"></slot></header><div class="icons-container"><slot name="icons" @slotchange="${IconsAndInfoBlock.handleSlotChange}"></slot></div><slot name="cta" class="cta-container"></slot></div>`;
    }
}
IconsAndInfoBlock.styles = css_248z;
__decorate([
    n({ type: Boolean, reflect: true })
], IconsAndInfoBlock.prototype, "rtl", void 0);
__decorate([
    n({ type: Boolean, reflect: true })
], IconsAndInfoBlock.prototype, "divider", void 0);
__decorate([
    n({ type: String, reflect: true })
], IconsAndInfoBlock.prototype, "styleType", void 0);
__decorate([
    t()
], IconsAndInfoBlock.prototype, "headingSlot", void 0);
__decorate([
    t()
], IconsAndInfoBlock.prototype, "textSlot", void 0);
__decorate([
    n({ type: Boolean })
], IconsAndInfoBlock.prototype, "isIcon", void 0);
__decorate([
    n({ type: Boolean, reflect: true })
], IconsAndInfoBlock.prototype, "enableSpacing", void 0);
__decorate([
    t()
], IconsAndInfoBlock.prototype, "isLarge", void 0);
customElements.define('icons-and-info-block', IconsAndInfoBlock);

export { IconsAndInfoBlock };
